export default "__VITE_ASSET__1cb49498__"